// mc-pdesc-cleanup.js — Rev 4.1
// Builds real, clickable mc-pdesc-accordion rows for ALL curated product descriptions.
// Handles three paragraph formats:
//   A) <strong>Label:</strong> value  (Guatemala, Whiskey Barrel Aged, …)
//   B) <strong>Label</strong>: value  (Cowboy Blend — colon outside the <strong>)
//   C) Unlabeled prose paragraph      (description/about text → "About This Coffee")
// Runs as a deferred script (DOM already parsed). Claims each curated container
// before the section's DOMContentLoaded accordion JS can touch it.
(function () {
  'use strict';

  var CHEVRON =
    '<span class="mc-pdesc-accordion__chevron" aria-hidden="true" focusable="false">' +
    '<svg viewBox="0 0 24 24" width="20" height="20" fill="none"' +
    ' stroke="#C9A44C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
    '<polyline points="6 9 12 15 18 9"></polyline></svg></span>';

  // Short label text → display label (key: strong text without colon)
  var LABEL_ALIAS = { 'Roast': 'Roast Level' };

  /* ── Helpers ─────────────────────────────────────────────────────────── */

  // Strips ALL inline style attributes from el and every descendant.
  function stripStyles(el) {
    el.removeAttribute('style');
    var descendants = el.querySelectorAll('[style]');
    for (var i = 0; i < descendants.length; i++) {
      descendants[i].removeAttribute('style');
    }
  }

  function makeDetails(title, contentHTML) {
    var det = document.createElement('details');
    det.className = 'mc-pdesc-accordion';
    var sum = document.createElement('summary');
    sum.innerHTML = title + CHEVRON;
    det.appendChild(sum);
    var div = document.createElement('div');
    div.className = 'mc-pdesc-content';
    div.innerHTML = contentHTML;
    det.appendChild(div);
    return det;
  }

  // Format A: <p><strong>Label:</strong> value</p>
  // Returns label text (without colon) if the first non-empty <strong> ends with ":"
  function getLabelText(el) {
    if (!el || el.tagName !== 'P') return null;
    var strongs = el.querySelectorAll('strong');
    for (var i = 0; i < strongs.length; i++) {
      var text = strongs[i].textContent.trim();
      if (!text) continue;                              // skip empty <strong></strong>
      if (text.charAt(text.length - 1) === ':') return text.slice(0, -1).trim();
      break;                                            // first non-empty strong, no colon → not format A
    }
    return null;
  }

  // Format B: <p><strong>Label</strong>: value</p>  OR  plain text "Label: value"
  // Matches if the paragraph's full text content starts with "Word(s): non-empty-value".
  // The label portion must be 1–40 characters with no colon.
  var PLAIN_LABEL_RE = /^([A-Za-z][^:]{0,39}):\s*(\S)/;

  function getPlainLabelText(el) {
    if (!el || el.tagName !== 'P') return null;
    var text = el.textContent.trim();
    var m = PLAIN_LABEL_RE.exec(text);
    if (!m) return null;
    return m[1].trim();
  }

  function getPlainLabelValue(el) {
    var text = el.textContent.trim();
    var colonIdx = text.indexOf(':');
    if (colonIdx < 0) return null;
    return text.slice(colonIdx + 1).trim();
  }

  // Returns coffee name text if el is a name <p> (<strong>Name</strong> with NO colon),
  // or null otherwise.
  function getCoffeeName(el) {
    if (!el || el.tagName !== 'P') return null;
    var strongs = el.querySelectorAll('strong');
    var label = null;
    for (var i = 0; i < strongs.length; i++) {
      var text = strongs[i].textContent.trim();
      if (!text) continue;
      label = text;
      break;
    }
    if (!label) return null;
    if (label.charAt(label.length - 1) === ':') return null;
    return label;
  }

  // Strips the <strong>Label:</strong> (or first non-empty <strong>) and the <br>
  // that may follow it from a cloned <p>, returning the remaining innerHTML.
  // Also strips all inline styles from the clone first.
  function fieldContentHTML(el) {
    var clone = el.cloneNode(true);
    stripStyles(clone);
    // Find first non-empty <strong> and remove it + any following <br>
    var strongs = clone.querySelectorAll('strong');
    for (var i = 0; i < strongs.length; i++) {
      if (!strongs[i].textContent.trim()) {
        strongs[i].parentNode.removeChild(strongs[i]);
        continue;
      }
      var next = strongs[i].nextSibling;
      strongs[i].parentNode.removeChild(strongs[i]);
      if (next && next.nodeName === 'BR') next.parentNode.removeChild(next);
      break;
    }
    return clone.innerHTML.trim();
  }

  /* ── Single-coffee builder ───────────────────────────────────────────── */
  // Layout with <hr>:    field <p>s before <hr>, description + <small> after <hr>
  // Layout without <hr>: all children are field <p>s (Guatemala-style) or plain
  //                      paragraphs (Cowboy Blend-style)

  function buildSingleAccordions(container, children) {
    var hrIdx = -1;
    for (var i = 0; i < children.length; i++) {
      if (children[i].tagName === 'HR') { hrIdx = i; break; }
    }
    var beforeHr = hrIdx >= 0 ? children.slice(0, hrIdx) : children;
    var afterHr  = hrIdx >= 0 ? children.slice(hrIdx + 1) : [];

    var accordions = [];
    var unlabeled  = [];   // prose paragraphs with no label → "About This Coffee"

    beforeHr.forEach(function (el) {
      // Format A: <strong>Label:</strong> structured field
      var label = getLabelText(el);
      if (label) {
        var displayLabel = LABEL_ALIAS[label] || label;
        var val = fieldContentHTML(el);
        if (val) accordions.push(makeDetails(displayLabel, val));
        return;
      }

      // Format B: plain "Label: value" text (colon outside <strong>, or no markup at all)
      var plainLabel = getPlainLabelText(el);
      if (plainLabel) {
        var displayLabel2 = LABEL_ALIAS[plainLabel] || plainLabel;
        var val2 = getPlainLabelValue(el);
        if (val2) accordions.push(makeDetails(displayLabel2, val2));
        return;
      }

      // Format C: unlabeled prose paragraph
      if (el.tagName === 'P') {
        var clone = el.cloneNode(true);
        stripStyles(clone);
        var txt = clone.textContent.trim();
        if (txt) unlabeled.push('<p>' + txt + '</p>');
      }
    });

    // Unlabeled paragraphs → label depends on product handle
    if (unlabeled.length) {
      var handle = (window.location.pathname.split('/products/')[1] || '').split('?')[0];
      var aboutLabel = /^cowboy/.test(handle) ? 'Tasting Profile' : 'About This Coffee';
      accordions.push(makeDetails(aboutLabel, unlabeled.join('')));
    }

    // Everything after <hr> → "Additional Details"
    if (afterHr.length) {
      var detailsHTML = afterHr.map(function (el) {
        var clone = el.cloneNode(true);
        stripStyles(clone);
        return clone.outerHTML;
      }).join('');
      accordions.push(makeDetails('Additional Details', detailsHTML));
    }

    while (container.firstChild) container.removeChild(container.firstChild);
    accordions.forEach(function (det) { container.appendChild(det); });
  }

  /* ── Sample-pack builder ─────────────────────────────────────────────── */
  // Section 0 (before first <hr>): intro paragraph(s) → "About This Pack"
  // Sections 1-N (between <hr>s):  coffee name <p> + field <p>s → one accordion each
  // Footer <p><small>…</small></p> in the last section is silently dropped.

  function buildPackAccordions(container, children) {
    var sections = [];
    var cur = [];
    children.forEach(function (el) {
      if (el.tagName === 'HR') { sections.push(cur); cur = []; }
      else cur.push(el);
    });
    if (cur.length) sections.push(cur);

    var accordions = [];

    // Intro → "About This Pack"
    if (sections.length > 0 && sections[0].length) {
      var introHTML = sections[0].map(function (el) {
        var clone = el.cloneNode(true);
        stripStyles(clone);
        return clone.outerHTML;
      }).join('');
      accordions.push(makeDetails('About This Pack', introHTML));
    }

    // Coffee sections
    for (var s = 1; s < sections.length; s++) {
      var sec = sections[s];
      if (!sec.length) continue;

      var coffeeName = getCoffeeName(sec[0]);
      var fieldStart = coffeeName ? 1 : 0;

      var fieldEls = sec.slice(fieldStart).filter(function (el) {
        if (el.tagName !== 'P') return false;
        if (el.querySelector('small') && !el.querySelector('strong')) return false;
        return getLabelText(el) !== null || getPlainLabelText(el) !== null;
      });

      var title = coffeeName || ('Coffee ' + s);
      var contentHTML = fieldEls.map(function (el) {
        var clone = el.cloneNode(true);
        stripStyles(clone);
        return clone.outerHTML;
      }).join('');
      if (title) accordions.push(makeDetails(title, contentHTML));
    }

    while (container.firstChild) container.removeChild(container.firstChild);
    accordions.forEach(function (det) { container.appendChild(det); });
  }

  /* ── Detection ───────────────────────────────────────────────────────── */

  // Curated: any direct child <p> has a field-label pattern (either format A or B).
  function isCurated(children) {
    return children.some(function (el) {
      return getLabelText(el) !== null || getPlainLabelText(el) !== null;
    });
  }

  // Pack: first child <p> is NOT a field label in any format
  // (it's an intro sentence, e.g. "Sample our best selling coffees…")
  function isPack(children) {
    if (!children.length) return false;
    var first = children[0];
    return getLabelText(first) === null && getPlainLabelText(first) === null;
  }

  /* ── Entry point ─────────────────────────────────────────────────────── */

  function run() {
    document.querySelectorAll('.product__description').forEach(function (container) {
      if (container.dataset.mcPdescDone) return;
      var children = Array.from(container.children);
      // Gate: only process containers with curated field-label structure (any format).
      if (!isCurated(children)) return;
      // Claim the container — section JS checks this flag on DOMContentLoaded
      container.dataset.mcPdescDone = '1';
      var hasHr = children.some(function (el) { return el.tagName === 'HR'; });
      if (hasHr && isPack(children)) buildPackAccordions(container, children);
      else buildSingleAccordions(container, children);
    });
  }

  // Deferred scripts execute after HTML parsing, before DOMContentLoaded —
  // so we can call run() synchronously here.
  run();

})();
